import { render, staticRenderFns } from "./NadpisEdit.vue?vue&type=template&id=8f8bccf6"
import script from "./NadpisEdit.vue?vue&type=script&lang=js"
export * from "./NadpisEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports